import { NavItem } from './NavItem';
import { navigation } from './navigation-items';

interface SidebarNavProps {
  collapsed: boolean;
}

export function SidebarNav({ collapsed }: SidebarNavProps) {
  return (
    <nav className="space-y-0.5 px-3">
      {navigation.map((item) => (
        <NavItem
          key={item.name}
          item={item}
          collapsed={collapsed}
        />
      ))}
    </nav>
  );
}